import { motion } from "framer-motion";
import SectionHeader from "@/components/SectionHeader";
import { INDUSTRIES } from "@/data/industries";

export default function IndustriesSection() {
  return (
    <section className="relative bg-navy text-white py-24 sm:py-32 overflow-hidden" data-testid="industries-section">
      <div className="absolute inset-0 hero-grid-overlay opacity-20" />
      <div className="absolute -top-32 -right-32 w-[480px] h-[480px] rounded-full bg-emerald-brand/20 blur-3xl" />

      <div className="relative container-x">
        <SectionHeader
          overline="Industries served"
          title={<>Trusted across the<br />sectors that <span className="text-gold">shape India</span>.</>}
          subtitle="Government, hospitality, retail, healthcare, education, sport and culture — the breadth of NEPHRC's mandate reflects two decades of multidisciplinary practice."
          inverse
        />

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {INDUSTRIES.map((ind, i) => {
            const Icon = ind.icon;
            return (
              <motion.div
                key={ind.title}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.45, delay: (i % 4) * 0.04 }}
                className="group relative overflow-hidden border border-white/10 aspect-[4/3] cursor-default"
                data-testid={`industry-card-${ind.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              >
                <img
                  src={ind.image}
                  alt={ind.title}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-60 transition-opacity duration-700 scale-110 group-hover:scale-100"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/60 to-transparent opacity-90 group-hover:opacity-80 transition-opacity" />
                <div className="relative h-full flex flex-col justify-between p-6">
                  <div className="w-11 h-11 grid place-items-center border border-white/20 text-gold group-hover:border-gold transition-colors">
                    <Icon size={18} strokeWidth={1.5} />
                  </div>
                  <div>
                    <div className="font-display font-semibold text-base leading-tight">{ind.title}</div>
                    <div className="mt-2 h-px w-8 bg-gold group-hover:w-16 transition-all duration-500" />
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
